import { getConfig } from './configs/index.js';
export const getBackendPath = (structureType) => getConfig(structureType).backend;
export const getPublicPath = (structureType) => getConfig(structureType).public;
export const getStylesPath = (structureType) => getConfig(structureType).styles;
